// components/modals/ComprobanteModal.js
import React from 'react';

const ComprobanteModal = ({
  show,
  onClose,
  modalTitle,
  modalContent,
  modalError,
  selectedCuota,
  handleConfirmarPagoPrepagado
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-lg relative p-6">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-slate-500 transition hover:text-slate-700"
          title="Cerrar"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 className="modal-title mb-4 text-red-700">
          {modalTitle}
        </h3>
        {modalError ? (
          <div className="rounded-xl border border-red-200 bg-red-50 p-4">
            <p className="text-red-800 font-medium">{modalError}</p>
          </div>
        ) : (
          <div className="space-y-4">
            {modalContent.comprobanteUrl ? (
              <div>
                <h4 className="modal-label">Comprobante de Pago</h4>
                <iframe
                  src={modalContent.comprobanteUrl}
                  title="Comprobante de Pago"
                  className="h-[70vh] w-full rounded-xl border border-slate-200"
                />
              </div>
            ) : (
              <div className="rounded-xl border border-yellow-200 bg-yellow-50 p-4">
                <p className="text-yellow-800 font-medium">No hay comprobante de pago disponible.</p>
              </div>
            )}
          </div>
        )}
        {selectedCuota && selectedCuota.estado === 'prepagado' && !modalError && (
          <div className="modal-actions mt-4">
            <button
              onClick={handleConfirmarPagoPrepagado}
              className="btn-modal-success"
            >
              Confirmar Pago
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ComprobanteModal;
